<div class="md:flex hidden flex-none w-6"></div>
<div *ngIf="controller.showTypeColumn$ | async" class="md:flex hidden flex-1">
	{{ controller.i18n + '.types.text' | translate }}
</div>
<div class="md:flex hidden flex-1">
	{{ controller.i18n + '.name.text' | translate }}
</div>
<div
	*ngIf="controller.showSectionColumn$ | async"
	class="md:flex hidden flex-1"
>
	{{ controller.i18n + '.sections.text' | translate }}
</div>
<div class="md:flex hidden flex-1">
	{{ controller.i18n + '.date.text' | translate }}
</div>
<div class="md:flex hidden flex-none w-16"></div>
